export const MAP_PROVIDERS = {
  GOOGLE: "Google",
  OPENSTREETMAP: "OpenStreetMap",
  SATELLITE: "Satellite",
  DARK: "Dark",
};

const TILE_LAYER_CONFIG = {
  [MAP_PROVIDERS.GOOGLE]: {
    url: "https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}",
    subdomains: ["mt1"],
    attribution: "Google Hybrid",
    maxZoom: 20,
  },
  [MAP_PROVIDERS.OPENSTREETMAP]: {
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    subdomains: ["a", "b", "c"],
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 19,
  },
  [MAP_PROVIDERS.SATELLITE]: {
    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
    subdomains: ["a", "b", "c"],
    attribution: "Tiles &copy; Esri &mdash; Source: Esri, Maxar, Earthstar Geographics, and the GIS User Community",
    maxZoom: 19,
  },
  [MAP_PROVIDERS.DARK]: {
    url: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png",
    subdomains: ["a", "b", "c", "d"],
    attribution: "&copy; OpenStreetMap contributors &copy; CARTO",
    maxZoom: 19,
  },
};

// Company Settings decides the single map style shown everywhere in the app.
export const getTileLayerConfig = (mapProvider) =>
  TILE_LAYER_CONFIG[mapProvider] || TILE_LAYER_CONFIG[MAP_PROVIDERS.OPENSTREETMAP];

const DEFAULT_MAP_VIEW = { center: [26.4499, 80.33], zoom: 12 };

// Company Settings decides which city maps open/zoom to by default, until a page has its own specific location to show.
export const getDefaultMapView = (generalSettingLists) => {
  const lat = parseFloat(generalSettingLists?.mapDefaultLatitude);
  const lng = parseFloat(generalSettingLists?.mapDefaultLongitude);
  const zoom = parseInt(generalSettingLists?.mapDefaultZoom, 10);

  return {
    center: [
      Number.isFinite(lat) ? lat : DEFAULT_MAP_VIEW.center[0],
      Number.isFinite(lng) ? lng : DEFAULT_MAP_VIEW.center[1],
    ],
    zoom: Number.isFinite(zoom) ? zoom : DEFAULT_MAP_VIEW.zoom,
  };
};
